import { existDFI } from "./existDFI"
import { existDFI_client } from "./existDFI_client";
import { existDRP } from "./existDRP.JS"
import { removeSpaces, searchElements, searchElementsHidden, showElementsHidden } from "./observerInputsRingpool"


export const optanon_groups_set=()=>{
    DFI_client.optanon_consent_preferences = true;
    if (typeof DFI_client.optanon_consent_preferences != "undefined") {
        var _paq = undefined;
        var Piwik = undefined;
        var womtp = undefined;
        
    }
}


export const storeOptanonValuesCookie=(dataOptanon)=>{
    
    for (var i = 0; i < dataOptanon.length; i++) {
        var item = dataOptanon[i];
        DFI_client["optanon_groups_" + item.id] = item.value;
        if (item.value !== "1") {
          DFI_client["optanon_groups_All_true"] = "False";
        }
      }
      if (!DFI_client.hasOwnProperty("optanon_groups_All_true")) {
        DFI_client["optanon_groups_All_true"] = "True";
      }
    
    
}



export const stopRingpool= ()=>{
   

        
        DRP.stopRingPool()
        searchElementsHidden()
    
}

export const startRingpool= async (dataOptanon)=>{   
        const phoneRingpoolActive=globalThis.DFI.telefonoRingPoolActivo
       
        DRP.init({
            defaultPhone: window.DFI.servicioActivo1.phoneCallCenterRingPool,
            capa: window.DFI.DFI_configuration.layers1,
            labels: window.DFI.labelsVarRingPool,
            campaignid: "23CCC7CC5348658F540F1E570B5D4709",
            reqPhone: function (data) {
                window.DFI.ringPoolCompleted = true;
                DFI.consoleLogDelio(data);
                const classTelefonos=document.querySelectorAll("drp_ring_container")
                // window.DFI.optionalRingPool, si true se activa con reglas window.DFI.DFI_configuration.services.ringPoolwindow.DFI.DFI_configuration.services.ringPool.active
                if ((window.DFI.DFI_configuration.services.ringPool.active && window.DFI.optionalRingPool !== true) ||
                    (window.DFI.DFI_configuration.services.ringPool.active && window.DFI.optionalRingPool === true &&
                        window.DFI.resultShowRules.actionIsOkInterferePhone)) {
                    // Con clase wal-drp-phone solo el href
                    for (var i = 0, len = classTelefonos.length; i < len; i++) {
                        var elemento = classTelefonos[i];
                        elemento.href = "tel:" + data.telefono;

                    }

                    // Con clase html-drp-phone solo el innerHTML
                    var htmlPhones = document.getElementsByClassName("drp_ring_container")
                    for (var i = 0, len = htmlPhones.length; i < len; i++) {
                        var elemento = htmlPhones[i];
                        elemento.innerHTML = DFI.buildMaskString(data.telefono, window.DFI.DFI_configuration.services.serviceList.ringPool.phoneMask);
                    }
                }



                window.DFI.telefonoRingPoolActivo = data.telefono;


            },
            called: function (data) {
                statusDFI.uid = data;
                window.c_var_9 = "RingPool";
                if (typeof DFI_client.customResponseOKEvent != "undefined") {
                    DFI_client.customResponseOKEvent();
                }
                DFI.loadConversion();
            },
            idTag: window.DFI.DFI_configuration.idTagDelioClient,
            maskPhone: window.DFI.DFI_configuration.services.serviceList.ringPool.phoneMask
        });

        searchElements(dataOptanon)
}


export const saveInboundFisrt= ()=>{
    
    let firstPhone=document.querySelector(".drp_ring_container").innerHTML;

    localStorage.setItem('inboundWalmeric',firstPhone);

}